import { Box, Link as ChakraLink, Float, Grid, Icon, WrapItem } from "@chakra-ui/react";
import { Link as ReactRouterLink, useLocation } from "react-router-dom";

import type { MenuItemProps } from "./types";

interface MenuItemContentProps extends MenuItemProps {
  isActive: boolean;
}

export default function AppMenuItem(props: MenuItemProps) {
  const { path = "", disabled, action } = props;
  const location = useLocation();
  const isActive = path ? location.pathname.endsWith(path) : false;

  return (
    <ChakraLink asChild outline="none" _hover={{ textDecoration: "none" }}>
      {path ? (
        <ReactRouterLink to={disabled ? "#" : path}>
          <AppMenuItemContent {...props} isActive={isActive} />
        </ReactRouterLink>
      ) : action ? (
        <Box onClick={action}>
          <AppMenuItemContent {...props} isActive={isActive} />
        </Box>
      ) : (
        <> </>
      )}
    </ChakraLink>
  );
}

function AppMenuItemContent(props: MenuItemContentProps) {
  const { isActive, icon, disabled, count } = props;
  return (
    <WrapItem>
      <Grid
        templateColumns="auto 1fr auto"
        alignItems="center"
        width="100%"
        height="2.5em"
        color={disabled ? "brand.muted" : isActive ? "brand.highlight" : "brand.contrast"}
        gap={0}
        _hover={{
          color: disabled ? "brand.muted" : "brand.highlight",
        }}
      >
        {icon && (
          <Box position="relative" ml="1">
            <Icon fontSize="1.5em" as={icon} />
            {count !== undefined && count > 0 && (
              <Float placement="bottom-start">
                <Box
                  minW="1.3em"
                  px="1"
                  h="1.3em"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                  color="brand.primary"
                  bg="artesian.highlight"
                  fontSize="2xs"
                  fontWeight="bold"
                >
                  {count}
                </Box>
              </Float>
            )}
          </Box>
        )}
      </Grid>
    </WrapItem>
  );
}
